.buttonWrapper {
  width: 100%;
  margin-top: 5px;
}